import { transport } from 'config/transport';

export function callApiGetDuChiCongDoan(congDoanId, academicYear) {
    return transport.get(`/congdoan/${congDoanId}/duchi`, { params: { academicYear } });
}
